<template>
    <div>
        <page-header title="Insights" class="insight-page-header"></page-header>
        <content-loader v-if="loading"/>
        <div class="insights-listing">
            <div class="container">
                <div class="row latest-insight align-items-lg-end">
                    <div class="col-md-12 col-lg-8 mb-4 mb-lg-0">
                        <insight-card
                            v-for="insight in recentInsights.slice(0,1)" 
                            :key="insight.id" 
                            v-router-link="{ name: 'InsightDetail', params: { id: insight.id }}" 
                            :insight="insight"
                            detail
                        ></insight-card>
                    </div>
                    <div class="col-lg-4">
                        <div class="side-block-cards row">
                            <insight-card
                                v-for="insight in recentInsights.slice(1,3)" 
                                :key="insight.id" 
                                v-router-link="{ name: 'InsightDetail', params: { id: insight.id }}" 
                                :insight="insight"
                                smallCard
                                class="col-md-6 col-lg-12"
                            ></insight-card>
                        </div>
                    </div>
                </div>

                <div v-if="insights">
                    <h2>Latest Articles</h2>
                    <div class="row">
                        <insight-card 
                            class="col-md-6 col-lg-4 insight" 
                            v-for="insight in insights" 
                            :key="insight.id" 
                            v-router-link="{ name: 'InsightDetail', params: { id: insight.id }}" 
                            :insight="insight"
                        ></insight-card>
                    </div>

                    <div class="see-more-btn text-center mb-5">
                        <content-loader v-if="loading" title="Insights"/>
                        <a v-if="showMoreEnabled" @click="updateOffset">
                            <p>See more</p>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import listInsights from '@/gql/ListInsights.gql';
import PageHeader from '@/components/global/PageHeader';
import ContentLoader from '@/components/global/ContentLoader'; 
import InsightCard from '@/components/insights/InsightCard'; 

const PER_PAGE = 12;

export default {
    name: 'insight-list',

    components: {
        PageHeader,
        ContentLoader,
        InsightCard,
    },

    apollo: {
        insights: {
            query: listInsights,
            variables() {
                return {
                    limit: PER_PAGE,
                    offset: 3
                }
            },
            loadingKey: 'loading',
            watchQuery: {fetchPolicy: 'network-only'},
            fetchPolicy: 'network-only',
        },

        totalInsights: listInsights,
        recentInsights: listInsights,
    },

    data() {
        return {
            insights: '',
            recentInsights: '',
            loading: 0,
            offset: 3,
            page: 0,
        }
    },

    computed:{
        showMoreEnabled() {
            return this.totalInsights && this.totalInsights.aggregate.count - 3 > this.insights.length;
        },
    },

    methods: {
        updateOffset() {
            this.page++;
            this.offset = this.page * PER_PAGE + 3;
            this.fetchData();
        },

        async fetchData() { 
            await this.$apollo.queries.insights.fetchMore({
                variables: {
                    limit: PER_PAGE,
                    offset: this.offset,
                },
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    if (!fetchMoreResult) {
                        return previousResult;
                    }
                    return Object.assign({}, previousResult, {
                        insights: [ ...previousResult.insights, ...fetchMoreResult.insights]
                    })
                },
            });
        },
    }
}
</script>

<style lang="scss" scoped>
    .insight-page-header {
        padding-bottom: 90px;

        @include media-breakpoint-up(md) {
            padding-bottom: 100px;
        }
    }

    .insights-listing {
        transform: translate(0, -100px);

        .latest-insight {
            margin-bottom: 35px;
        }

        .side-block-cards {
            justify-content: flex-end;

            > div:first-of-type {
                margin-bottom: 25px;
                @include media-breakpoint-up(md) {
                    margin-bottom: 0;
                }
                @include media-breakpoint-up(lg) {
                    margin-bottom: 40px;
                }
            }
        }

        h2 {
            font-size: 28px;
            font-weight: 700;
            line-height: 1.5;
            margin-bottom: 30px;
        }

        .insight {
            margin-bottom: 25px;
            @include media-breakpoint-up(md) {
                margin-bottom: 40px;
                transition: all .2s ease-in-out;
                &:hover {
                    transform: scale(1.05);
                }
            }
        }
    }
</style>
